// @flow
/**
 * Created by Mike Chung on 2/9/18.
 */
import {Country} from "../model/Country";
import config from "../config/config";

export async function loadCountries(): Promise<Array<Country>> {

    try {
        let response = await fetch(`${config.countryListAPI}`, {
            headers: {
                "content-type": "text/plain"
            }
        });

        if (response.status > 200) {

            let error = new Error(response.statusText);
            // $FlowFixMe
            error.response = response;
            throw error;
        } else {
            let countries = await response.json();
            return countries;
        }

    } catch (e) {
        throw e;
    }
}



// WEBPACK FOOTER //
// ./src/dao/countryDao.js